import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  UserProfessionalProfile,
  UserProfileAPIResponse,
} from "../../types/userTypes";

import axios from "axios";
import { nuclearn_api_url } from "../../App";

const getUserProfile = (): Promise<UserProfileAPIResponse> => {
  return axios.get(`${nuclearn_api_url}/user/profile`).then((response) => {
    return response.data;
  });
};

export const useGetUserProfile = () => {
  return useQuery(["userProfile"], () => getUserProfile(), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 5, // 5 minutes
  });
};

const updateUserProfile = (
  profileData: UserProfessionalProfile,
): Promise<UserProfileAPIResponse> => {
  return axios
    .put(`${nuclearn_api_url}/user/profile`, profileData)
    .then((response) => {
      return response.data;
    });
};

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(updateUserProfile, {
    onSuccess: () => {
      // Invalidate and refetch user profile data
      queryClient.invalidateQueries(["userProfile"]);
    },
    onError: (error: any) => {
      console.log("Error updating user profile:", error.response);
    },
  });

  return mutation;
};

const resetOnboarding = (): Promise<{ status: string }> => {
  return axios
    .post(`${nuclearn_api_url}/user/onboarding/reset`)
    .then((response) => response.data);
};

export const useResetOnboarding = () => {
  const queryClient = useQueryClient();
  return useMutation(resetOnboarding, {
    onSuccess: () => queryClient.invalidateQueries(["userProfile"]),
  });
};
